export var DATE_OF_BIRTH = /(0[1-9]|1[012])[- /.](0[1-9]|[12][0-9]|3[01])[- /.](19|20)\d\d/;
export var EMAIL = /^([a-zA-Z0-9_\-+.]+)@([a-zA-Z0-9_\-.]+)\.([a-zA-Z]{2,})$/;
export var PHONE_NUMBER = /\+?1?(([0-9]{3})|(\([0-9]{3}\)))[ -]?([0-9]{3})[ -]?([0-9]{4})/gim;
